// ============ DEFAULT PAGE CONTENT DISPATCHER ============
// Maps page keys to their template content.
// Templates are kept in separate modules because they're large.

import {
  headTemplate,
  headerTemplate,
  navmenuTemplate,
  footerTemplate,
} from './defaultPageContentLayout';

import {
  homeTemplate,
  produitsTemplate,
  serviceTemplate,
  aproposTemplate,
  blogTemplate,
  contactTemplate,
  bookingTemplate,
  bookingsuccessTemplate,
  faqTemplate,
  galleryTemplate,
  equipeTemplate,
  partenairesTemplate,
  projectTemplate,
  detailsproduitTemplate,
  detailsserviceTemplate,
  detailsblogTemplate,
  detailsproduitsTemplate,
} from './defaultPageContentCore';

import {
  connexionTemplate,
  creationcompteTemplate,
  recuperationTemplate,
  resetpasswordTemplate,
  loginTemplate,
  conditionsdutilisationTemplate,
  politiqueTemplate,
  retoursTemplate,
  marketplaceTemplate,
  marketplaceSellerTemplate,
  marketplaceCustomerTemplate,
  panierTemplate,
  detailsformTemplate,
  fichieraiTemplate,
  workspacepublicTemplate,
  defaultTemplate,
} from './defaultPageContentExtras';

/** Page Hébergements : recherche filtrée (hôtel, riad, villa…) + liste. */
function hebergementTemplate(): string {
  return `<section class="page-header">
  <div class="container">
    <span class="page-tag">Hébergements</span>
    <h1>Nos hébergements</h1>
    <p>Hôtels, riads, villas, appartements et maisons d'hôtes — réservez en direct, disponibilités en temps réel.</p>
  </div>
</section>
<section class="section">
  <div class="container">{{hebergement_search}}</div>
</section>
<section class="section section-alt">
  <div class="container">{{hebergements limit="9"}}</div>
</section>
<section class="section">
  <div class="container">{{contact_form}}</div>
</section>`;
}

/** Page Événements : agenda du commerce + formulaire par défaut. */
function evenementTemplate(): string {
  return `<section class="page-header">
  <div class="container">
    <span class="page-tag">Événements</span>
    <h1>Nos événements</h1>
    <p>Retrouvez les prochains rendez-vous, ateliers et temps forts de {{site_name}}.</p>
  </div>
</section>
<section class="section">
  <div class="container">{{events limit="12"}}</div>
</section>
<section class="section section-alt">
  <div class="container">{{default_form}}</div>
</section>`;
}

export function getDefaultPageContent(pageKey: string): string {
  switch (pageKey) {
    // Layout
    case 'head': return headTemplate();
    case 'header': return headerTemplate();
    case 'navmenu': return navmenuTemplate();
    case 'footer': return footerTemplate();

    // Core pages
    case 'home': return homeTemplate();
    case 'produits': return produitsTemplate();
    case 'hebergement': return hebergementTemplate();
    case 'evenement': return evenementTemplate();
    case 'service': return serviceTemplate();
    case 'apropos': return aproposTemplate();
    case 'blog': return blogTemplate();
    case 'contact': return contactTemplate();
    case 'booking': return bookingTemplate();
    case 'bookingsuccess': return bookingsuccessTemplate();
    case 'faq': return faqTemplate();
    case 'gallery': return galleryTemplate();
    case 'equipe': return equipeTemplate();
    case 'partenaires': return partenairesTemplate();
    case 'project': return projectTemplate();

    // Detail pages
    case 'detailsproduit': return detailsproduitTemplate();
    case 'detailsservice': return detailsserviceTemplate();
    case 'detailsblog': return detailsblogTemplate();
    case 'detailsproduits': return detailsproduitsTemplate();

    // Auth pages
    case 'connexion': return connexionTemplate();
    case 'creationcompte': return creationcompteTemplate();
    case 'recuperation': return recuperationTemplate();
    case 'resetpassword': return resetpasswordTemplate();
    case 'login': return loginTemplate();

    // Legal
    case 'conditionsdutilisation': return conditionsdutilisationTemplate();
    case 'politique': return politiqueTemplate();
    case 'retours': return retoursTemplate();

    // Marketplace
    case 'marketplace': return marketplaceTemplate();
    case 'marketplace-seller': return marketplaceSellerTemplate();
    case 'marketplace-customer': return marketplaceCustomerTemplate();

    // Other
    case 'panier': return panierTemplate();
    case 'detailsform': return detailsformTemplate();
    case 'fichierai': return fichieraiTemplate();
    case 'workspacepublic': return workspacepublicTemplate();

    // Generous fallback
    default: return defaultTemplate();
  }
}